const OVERRIDE_TOP_BAR = 'override-top-bar';
const SET_ADI_TOOLTIP_VISIBILITY = 'set-adi-tooltip-visibility';
const SET_BANNER_TITLE = 'set-banner-title';

export { OVERRIDE_TOP_BAR, SET_ADI_TOOLTIP_VISIBILITY, SET_BANNER_TITLE };
